import { Skeleton } from "@mantine/core";
import { useNavigate, useParams, useSearch } from "@tanstack/react-router";

import { useGetCatalog } from "../../../api/generated/endpoints/generation/generation";
import { ErrorAlert } from "../../../platform/ErrorAlert";
import { CreateFrame } from "./CreateFrame";
import classes from "./create.module.css";
import { ImageForm } from "./ImageForm";
import { RecentResults } from "./RecentResults";

const ROUTE = "/signed-in/teams/$teamId/brands/$brandId/home2/create-image";

/** The prototype's `#create-image`: Image or Ad static, then the recent image results. */
export function CreateImageScreen() {
  const { teamId, brandId } = useParams({ from: ROUTE });
  const mode = useSearch({ from: ROUTE, select: (search) => search.mode ?? "image" });
  const navigate = useNavigate({ from: "/teams/$teamId/brands/$brandId/home2/create-image" });
  const catalog = useGetCatalog();
  const composer = catalog.isError ? (
    <ErrorAlert error={catalog.error} />
  ) : catalog.data === undefined ? (
    <Skeleton className={classes.composerSkeleton} />
  ) : (
    <ImageForm
      // A brand's own draft: a switch drops the old brand's product, references and pictures, as
      // the Studio's composer does.
      key={brandId}
      catalog={catalog.data}
      mode={mode}
      onMode={(next) => {
        void navigate({ search: next === "image" ? {} : { mode: next }, replace: true });
      }}
    />
  );
  return (
    <CreateFrame
      composer={composer}
      results={<RecentResults teamId={teamId} brandId={brandId} medium="image" noun="image" />}
    />
  );
}
